import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  updateNotifications: ['notifications'],
  addNotification: ['notification'],
});

export const NotificationTypes = Types;
export default Creators;
